import type { SxProps, Theme } from '@mui/material/styles';

export type StatusConfig = {
  bgColor: string;
  borderColor?: string;
  textColor?: string;
};

export const getAccordionSx = (
  isDarkMode: boolean,
  status: StatusConfig
): SxProps<Theme> => ({
  ...(isDarkMode &&
    status.borderColor && {
      border: `2px solid ${status.borderColor}30`,
      borderRadius: '8px'
    })
});

export const getAccordionHeaderSx = (
  isDarkMode: boolean,
  status: StatusConfig,
  isExpanded: boolean
): SxProps<Theme> => ({
  backgroundColor: status.bgColor,
  borderRadius: isExpanded ? '8px 8px 0 0' : '8px',
  ...(isDarkMode &&
    status.borderColor &&
    isExpanded && {
      borderBottom: `1px solid ${status.borderColor}40`
    })
});

export const getAccordionTitleSx = (
  isDarkMode: boolean,
  status: StatusConfig
): SxProps<Theme> => ({
  color: isDarkMode && status.textColor ? `${status.textColor}cc` : 'inherit'
});

export const getTestGridPaperSx = (isDarkMode: boolean): SxProps<Theme> => ({
  p: 3,
  borderRadius: 2,
  backgroundColor: isDarkMode ? '#000000' : 'background.paper'
});
